import LAlert from './LAlert.vue'

export default (Vue) => {
  Vue.component(LAlert.name, LAlert)
}
